import { Root } from '@radix-ui/react-accordion'
import React from 'react'

import { cn } from '~/styled'

import { AccordionContent } from './AccordionContent'
import { AccordionItem } from './AccordionItem'
import { AccordionTrigger } from './AccordionTrigger'

type AccordionProps = React.ComponentProps<typeof Root> & {
  type: 'single' | 'multiple'
}

type AccordionType = ReturnType<
  typeof React.forwardRef<HTMLDivElement, AccordionProps>
> & {
  Item: typeof AccordionItem
  Content: typeof AccordionContent
  Trigger: typeof AccordionTrigger
}

export const Accordion = React.forwardRef<HTMLDivElement, AccordionProps>(
  ({ type = 'single', className, children, ...remainingProps }, ref) => (
    // eslint-disable-next-line
    // @ts-ignore TODO: Radix has an TS error that throws a warning if you pass multiple in. Needs to be fixed by the owner
    <Root
      ref={ref}
      type={type}
      className={cn('w-full', className)}
      {...remainingProps}
    >
      {children}
    </Root>
  )
) as AccordionType

Accordion.Item = AccordionItem
Accordion.Content = AccordionContent
Accordion.Trigger = AccordionTrigger

Accordion.displayName = 'Accordion'
